import {IStore} from "modules/store";
import {createSelector} from "@reduxjs/toolkit";

const getState = ({common}: IStore) => common;

export const getIsMenuOpen = createSelector(getState, (state) => state.isMenuOpen);
